import React, {PropsWithChildren} from "react";

import {pb, pt} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

export const SiteMapHeading = (props: PropsWithChildren) => {
    return (
        <Text as="h1" variant="headline_3" css={[pt(2), pb(3)]}>
            {props.children}
        </Text>
    );
};
import React, {PropsWithChildren} from "react";

import {pb, pt} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

export const SiteMapHeading = (props: PropsWithChildren) => {
    return (
        <Text as="h1" variant="headline_3" css={[pt(2), pb(3)]}>
            {props.children}
        </Text>
    );
};
